import React, { Component, Fragment } from 'react';
import DEFINE, { PATHS } from "../../../../constants/Define";
import { Link } from 'react-router-dom';
import * as Func from '../../../../helpers/functions';
import * as HMS from "../../common/component/Index";
import CustomPriceList from './CustomPriceList';
import Ripple from '../../common/component/Ripple';

let permisionActions = [];
export default class CustomPrices extends Component {
    constructor(props) {
        super(props);
        this.state = {
            filters: {
                hotelId: undefined,
                pageIndex: this.props.customPriceState.pageIndex,
                pageSize: this.props.customPriceState.pageSize,
            },
        };
    }

    componentDidMount() {
        permisionActions = Func.getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.CUSTOM_PRICE);
        this.initPrices();
    }

    render() {
        const { t, hotelState } = this.props;
        const { isFetching, totalCount, totalPage, pageIndex, prices } = this.props.customPriceState;
        const pagination = { totalCount, totalPage, defaultCurrent: pageIndex };
        const { filters } = this.state;
        return (
            <Fragment>
                <HMS.PageListComponent>
                    <HMS.HeaderListComponent
                        path={this.props.match.path}
                        groupPath={'prices'}
                        titleHeader={`${t('navigation.customPrices')} - ${hotelState?.detail?.hotel?.name || ""}`}
                        onClickBack={this.onClickBack}
                        componentRight={
                            <Fragment>{
                                permisionActions && permisionActions.allowCreate &&
                                <Ripple color="rgba(255, 255, 255, 0.8)" waitForEffect={true}>
                                    <Link to={Func.getPathWithParams(PATHS.CUSTOM_PRICE.CREATE.path, { hotel_id: filters.hotelId })}
                                        className='btn btn-primary'>+ {t(`action.create`)}</Link>
                                </Ripple>
                            }
                            </Fragment>
                        }
                    />
                    <CustomPriceList loading={isFetching}
                        hotelId={filters.hotelId}
                        permisions={permisionActions}
                        prices={prices}
                        pagination={pagination}
                        onChange={this.onTableChange}
                        onDeletePrice={this.onDeletePrice}
                    />
                </HMS.PageListComponent>
            </Fragment>
        );
    }

    initPrices() {
        const { match, hotelState } = this.props;
        let hotelId;
        if (hotelState.detail.hotel && hotelState.detail.hotel.id) {
            hotelId = hotelState.detail.hotel.id;
        } else if (Object.keys(match.params).length > 0 && match.params.hotel_id) {
            hotelId = match.params.hotel_id;
        }
        const filters = { ...this.state.filters, hotelId };
        this.setState({ filters });
        this.props.getListPrices(filters);
        if(hotelId){
            this.props.getHotelDetail(hotelId);
        }
    }

    onTableChange = (pagination, filters, sorter) => {
        let curfilters = this.state.filters;
        if (filters.status) {
            switch (filters.status[0]) {
                case 998:
                    filters = Func.removeElementObject(filters, 'status');
                    curfilters = Func.removeElementObject(curfilters, 'status');
                    curfilters = Func.removeElementObject(curfilters, 'isExpired');
                    filters.IsLocked = true;
                    break;
                case 999:
                    filters = Func.removeElementObject(filters, 'status');
                    curfilters = Func.removeElementObject(curfilters, 'status');
                    curfilters = Func.removeElementObject(curfilters, 'IsLocked');
                    filters.isExpired = true;
                    break;
                default:
                    if (filters.status[0] !== 998) { curfilters = Func.removeElementObject(curfilters, 'IsLocked') }
                    if (filters.status[0] !== 999) { curfilters = Func.removeElementObject(curfilters, 'isExpired') }
            }
        }
        let newFilters = Func.genaratePaginateFilterSort(pagination, filters, sorter);
        this.setState({
            filters: newFilters
        });
        this.props.getListPrices(newFilters);
    };

    onDeletePrice = (priceItem) => {
    }

    onClickBack = () => {
        const { match } = this.props;
        if (Object.keys(match.params).length > 0 && match.params.hotel_id) {
            const path = Func.getPathWithParams(PATHS.HOTEL.DETAIL.path, { id: match.params.hotel_id })
            this.props.history.push(path);
        }
    }


}
